import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import Header from './Header';

const Hero = () => {
  return (
    <div className="hero-section">
      <div className="hero-header">
        <Header />
      </div>
      <div className="hero-content">
        <span className="hero-badge">Туристическое агентство · Узбекистан</span>
        <h1>Путешествия по всему миру с Asian Tour</h1>
        <p className="hero-description">
          Подберём тур, забронируем отель и организуем поездку под ключ.
          Индивидуальные маршруты, горящие предложения и поддержка 24/7.
        </p>
        <div className="hero-actions">
          <Link to="/book" className="btn-primary">Забронировать с нами</Link>
          <Link to="/self-booking" className="btn-secondary hero-btn-light">Сам бронирую</Link>
        </div>
        <div className="hero-stats">
          <div className="hero-stat">
            <strong>15+</strong>
            <span>лет опыта</span>
          </div>
          <div className="hero-stat">
            <strong>50+</strong>
            <span>направлений</span>
          </div>
          <div className="hero-stat">
            <strong>24/7</strong>
            <span>поддержка</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
